import { useProduct } from '../ProductCard';
import { useFormatProductWeight } from '@monofront/business/hooks/product/useFormatProductWeight';

export const ProductFormat = () => {
  const product = useProduct();
  const { formatProductWeight } = useFormatProductWeight();
  const formattedWeight = formatProductWeight(product?.meta.finance, true);

  if (!product) {
    return (
      <div
        data-testid="product-weight-formatted-empty"
        className="tw-m-2 tw-h-6 tw-w-10/12 tw-animate-pulse tw-rounded-md tw-bg-black-200 tw-grid-area-[format]"
      ></div>
    );
  }

  if (!formattedWeight) return null;

  return (
    <p
      data-testid="product-weight-formatted"
      className="tw-flex tw-items-center tw-text-sm tw-text-black-700 tw-grid-area-[format]"
    >
      <b>{formattedWeight}</b>
    </p>
  );
};
